import { Injectable } from '@angular/core';
import { PostHogUserProfileService } from './posthog-user-profile.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class PostHogAuthIntegrationService {

  constructor(
    private _posthogUserProfileService: PostHogUserProfileService,
    private _storageService: StorageService
  ) {}

  /**
   * Handle user login - call this after successful authentication
   */
  handleUserLogin(userData: any): void {
    if (userData && userData.id) {
      // Identify the user with PostHog
      this._posthogUserProfileService.identifyAuthenticatedUser({
        id: userData.id.toString(),
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        isOwner: userData.isOwner
      });

      // Track the login event
      this._posthogUserProfileService.trackUserLogin(userData.id.toString());
    }
  }

  /**
   * Handle user logout - call this before clearing auth data
   */
  handleUserLogout(): void {
    try {
      // Get current user before clearing data
      const currentUser = this._storageService.getObject('currentUser');
      const userId = currentUser?.id?.toString();

      // Track logout event
      this._posthogUserProfileService.trackUserLogout(userId);

      // Reset PostHog profile
      this._posthogUserProfileService.resetUserProfile();
    } catch (error) {
      console.error('Error handling PostHog logout:', error);
    }
  }

  /**
   * Initialize anonymous user profile
   */
  initializeAnonymousProfile(): void {
    this._posthogUserProfileService.initializeUserProfile();
  }
}
